.option {
  padding: 6px 8px;
  display: flex;
  align-items: center;
}

.option:hover {
  background-color: var(--hover-light);
}

.option > input {
  margin-right: 10px;
}

.option > label {
  width: 100%;
}

.unselectable {
  user-select: none;
}
